export const environment = {
  production: true,
  sentry: {
    dsn: 'https://625f77bce66956a41cbefcc3422a24ec@o4506841913491456.ingest.us.sentry.io/4507145965862912'
  },
  reactFrontendDomain: null as string | null
};
